import { render, staticRenderFns } from "./404.vue?vue&type=template&id=b6d14eca&scoped=true&"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=b6d14eca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d14eca",
  null
  
)

export default component.exports